import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './Sidebar.css';
import smallLogo from './small-logo.png';

const Sidebar: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const navigationButtons = [
    { label: 'Dashboard', path: '/admin', available: true, icon: '📊' },
    { label: 'Booking', path: '/admin/bookings', available: true, icon: '📋' },
    { label: 'Nhà cung cấp', path: '/admin/providers', available: true, icon: '🧑' },
    { label: 'Khách hàng', path: '/admin/customers', available: true, icon: '👤' },
    { label: 'Hoa hồng', path: '/admin/manage-commissions', available: true, icon: '💸' },
    { label: 'Lịch sử nạp tiền', path: '/admin/manage-deposit-history', available: true, icon: '💳' },
    { label: 'Tin nhắn', path: '/admin/manage-conversations', available: true, icon: '💬' },
    { label: 'Đánh giá', path: '/admin/manage-reviews', available: true, icon: '⭐' },
    { label: 'Khuyến mãi', path: '/admin/manage-discount-codes', available: true, icon: '🏷️' },
    { label: 'Gói dịch vụ', path: '/admin/manage-service-items', available: true, icon: '🧰' },
    { label: 'Dịch vụ', path: '/admin/manage-subcategories', available: true, icon: '🛠️' },
    { label: 'Ngành nghề', path: '/admin/manage-services', available: true, icon: '🗂️' },
    { label: 'Cài đặt', path: '/admin/settings', available: true, icon: '⚙️' }
  ];

  return (
    <div className="sidebar">
      <div className="navigation-list">
        {navigationButtons.map((button, index) => (
          <button
            key={index}
            className={`nav-button ${!button.available ? 'nav-button-disabled' : ''} ${location.pathname === button.path ? 'nav-button-active' : ''}`}
            onClick={() => {
              if (button.available) {
                navigate(button.path);
              } else {
                alert(`Tính năng "${button.label}" sẽ được cập nhật trong phiên bản tiếp theo!`);
              }
            }}
          >
            <span className="nav-icon" aria-hidden="true">{button.icon}</span>
            <span className="nav-label">{button.label}</span>
          </button>
        ))}
      </div>
      <div className="sidebar-logo">
        <img src={smallLogo} alt="Fconnect Logo" />
      </div>
    </div>
  );
};

export default Sidebar; 